import { createContext, useContext, useState, useEffect } from 'react';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [loading, setLoading] = useState(true);
  const [user, setUser] = useState(() => {
    const token = localStorage.getItem('token');
    const role  = localStorage.getItem('role');
    const name  = localStorage.getItem('name');
    const id    = localStorage.getItem('id');
    return token ? { token, role, name, id } : null;
  });

  useEffect(() => {
    // Rehydrate from localStorage on mount
    const token = localStorage.getItem('token');
    const role  = localStorage.getItem('role');
    const name  = localStorage.getItem('name');
    const id    = localStorage.getItem('id');

    if (token && role) {
      setUser({ token, role, name, id });
    } else {
      setUser(null);
    }
    setLoading(false);
  }, []);

  const login = (data) => {
    const token = data.token;
    const role  = data.role  ?? data.user?.role;
    const name  = data.name  ?? data.user?.name;
    const id    = data.id    ?? data.user?.id;

    localStorage.setItem('token', token);
    localStorage.setItem('role',  role);
    localStorage.setItem('name',  name);
    localStorage.setItem('id',    String(id));

    setUser({ token, role, name, id: String(id) });
  };

  const logout = () => {
    localStorage.clear();
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, setUser, login, logout, loading }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);